
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import useFetchCountries from "../../hooks/useFetchCountries";
import useFetchCities from "../../hooks/useFetchCities";
import useFetchStates from "../../hooks/useFetchStates";
import { ApiUrl } from "../../../ApiUrl";
import Select from "react-select";
import {
  validateAadhar,
  validatePhoneNumber,
  validateEmail,
} from "../../utils/validation";

const ParentDetailsForm = ({ formData, setFormData }) => {
  const {
    countries,
    loading: loadingCountries,
    error: errorCountries,
  } = useFetchCountries();
  const {
    cities,
    loading: loadingCities,
    error: errorCities,
  } = useFetchCities();
  const {
    states,
    loading: loadingStates,
    error: errorStates,
  } = useFetchStates();

  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [isSameAddress, setIsSameAddress] = useState(false);
  const [errors, setErrors] = useState({
    present_phone_number: "",
    permanent_phone_number: "",
    present_pincode: "",
    permanent_pincode: "",
  });


  // const odishaDistrictOptions = odishaPincodeData.districts.map((district) => ({
  //   value: district.name,
  //   label: district.name,
  // }));

  // const getPincodeOptions = (districtName) => {
  //   const district = odishaPincodeData.districts.find(
  //     (item) => item.name === districtName
  //   );
  //   return district
  //     ? district.pincodes.map((pincode) => ({ value: pincode, label: pincode }))
  //     : [];
  // };

  // const presentPincodeOptions = getPincodeOptions(formData.present_district);
  // const permanentPincodeOptions = getPincodeOptions(
  //   formData.permanent_district
  // );

  const odishaDefaultCountry =
    countries.find((c) => c.countrydesc.toLowerCase() === "india")?.countrycode ||
    "IN";
  const odishaDefaultState =
    states.find((s) => s.statedesc.toLowerCase() === "odisha")?.statecode ||
    "OR";


  const fetchStudentData = async () => {
    try {
      const response = await fetch(
        `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetStudentDetailsBasedOnId/${id}`
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const result = await response.json();
      console.log("Fetched Student Data:", result);

      if (result && result.data && result.data.address_details?.length > 0) {
        const addressDetails = result.data.address_details[0];

        // Convert label values like "INDIA" to value like "IN"
        const present_country_code =
          countries.find(
            (c) =>
              c.countrydesc.toLowerCase() ===
              (addressDetails.present_country || "").toLowerCase()
          )?.countrycode || "";

        const permanent_country_code =
          countries.find(
            (c) =>
              c.countrydesc.toLowerCase() ===
              (addressDetails.permanent_country || "").toLowerCase()
          )?.countrycode || "";

        const present_state_code =
          states.find(
            (s) =>
              s.statedesc.toLowerCase() ===
              (addressDetails.present_state || "").toLowerCase()
          )?.statecode || "";

        const permanent_state_code =
          states.find(
            (s) =>
              s.statedesc.toLowerCase() ===
              (addressDetails.permanent_state || "").toLowerCase()
          )?.statecode || "";

        const present_city_code =
          cities.find(
            (c) =>
              c.cityname.toLowerCase() ===
              (addressDetails.present_district || "").toLowerCase()
          )?.cityname || "";

        const permanent_city_code =
          cities.find(
            (c) =>
              c.cityname.toLowerCase() ===
              (addressDetails.permanent_district || "").toLowerCase()
          )?.cityname || "";

        setFormData((prevData) => ({
          ...prevData,
          present_address: addressDetails.present_address || "",
          present_district: present_city_code,
          present_state: present_state_code,
          present_country: present_country_code,
          present_pincode: addressDetails.present_pincode || "",
          present_phone_number: addressDetails.present_phone_number || "",
          permanent_address: addressDetails.permanent_address || "",
          permanent_district: permanent_city_code,
          permanent_state: permanent_state_code,
          permanent_country: permanent_country_code,
          permanent_pincode: addressDetails.permanent_pincode || "",
          permanent_phone_number: addressDetails.permanent_phone_number || "",
        }));
      } else {
        console.error("No address details found for the student.");
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching student data:", error);
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (
  //     id &&
  //     !formData.present_address &&
  //     countries.length &&
  //     states.length &&
  //     cities.length
  //   ) {
  //     fetchStudentData();
  //   } else if (!id) {
  //     setLoading(false);
  //   }
  // }, [id, formData, countries, states, cities]);

  useEffect(() => {
    if (id && countries.length && states.length && cities.length) {
      fetchStudentData();
    } else if (!id) {
      setLoading(false);
    }
  }, [id, countries.length, states.length, cities.length]);

  const handleCheckboxChange = () => {
    setIsSameAddress((prev) => {
      const newSameAddress = !prev;

      if (newSameAddress) {
        setFormData((prevData) => ({
          ...prevData,
          permanent_address: prevData.present_address,
          permanent_district: prevData.present_district,
          permanent_state: prevData.present_state,
          permanent_country: prevData.present_country,
          permanent_pincode: prevData.present_pincode,
          permanent_phone_number: prevData.present_phone_number,
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
          permanent_address: "",
          permanent_district: "",
          permanent_state: "",
          permanent_country: "",
          permanent_pincode: "",
          permanent_phone_number: "",
        }));
      }

      return newSameAddress;
    });
  };

  const validatePincodeByDistrict = async (fieldName, pincode, districtName) => {
    if (!pincode) {
      setErrors((prev) => ({ ...prev, [fieldName]: "" }));
      return true;
    }

    if (!/^\d{6}$/.test(pincode)) {
      setErrors((prev) => ({
        ...prev,
        [fieldName]: "Pincode must be exactly 6 digits.",
      }));
      return false;
    }

    if (!districtName) {
      setErrors((prev) => ({
        ...prev,
        [fieldName]: "Please select City/District first.",
      }));
      return false;
    }

    try {
      const response = await fetch(
        `https://api.postalpincode.in/pincode/${pincode}`
      );
      const data = await response.json();
      const record = Array.isArray(data) ? data[0] : null;

      if (
        !record ||
        record.Status !== "Success" ||
        !Array.isArray(record.PostOffice)
      ) {
        setErrors((prev) => ({ ...prev, [fieldName]: "Invalid pincode." }));
        return false;
      }

      const selectedDistrict = String(districtName).trim().toLowerCase();
      const isMatched = record.PostOffice.some((postOffice) => {
        const candidates = [
          postOffice?.District,
          postOffice?.Name,
          postOffice?.Division,
          postOffice?.Block,
        ]
          .filter(Boolean)
          .map((value) => String(value).trim().toLowerCase());

        return candidates.includes(selectedDistrict);
      });

      const errorMessage = isMatched
        ? ""
        : `Pincode does not belong to selected district (${districtName}).`;

      setErrors((prev) => ({ ...prev, [fieldName]: errorMessage }));
      return isMatched;
    } catch (error) {
      setErrors((prev) => ({
        ...prev,
        [fieldName]: "Unable to validate pincode. Please try again.",
      }));
      return false;
    }
  };

  const handleInputChange = (e) => {
  const { name } = e.target;
  let value = e.target.value;

    // Create a copy of current errors state to update it
    const updatedErrors = { ...errors };

    if (name === "present_phone_number" || name === "permanent_phone_number") {
      if (!validatePhoneNumber(value)) {
        updatedErrors[name] = "Phone number must contain only numbers.";
      } else if (value.length < 10) {
        updatedErrors[name] = "Phone number must be exactly 10 digits.";
      } else {
        updatedErrors[name] = ""; // Clear error if valid
      }
    }


      if (name === "present_pincode" || name === "permanent_pincode") {
        // sanitize to digits only
        let sanitized = value.replace(/[^0-9]/g, "");
        if (sanitized.length > 6) sanitized = sanitized.slice(0, 6);

        if (sanitized.length > 0 && sanitized.length < 6) {
          updatedErrors[name] = "Pincode must be exactly 6 digits";
        } else if (sanitized.length === 6) {
          const districtKey =
            name === "present_pincode" ? "present_district" : "permanent_district";
          const districtVal = formData[districtKey] || "";

          if (!districtVal) {
            updatedErrors[name] = "Please select City/District first.";
          } else {
            updatedErrors[name] = "";
            validatePincodeByDistrict(name, sanitized, districtVal);
          }
        } else {
          updatedErrors[name] = "";
        }

        // replace value with sanitized value for storage below
        value = sanitized;
      }


    setErrors(updatedErrors); // Update the error state

    // Update form data state
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // if (loading) {
  //   return <div>Loading student data...</div>;
  // }

  return (
    <div className="container-fluid">
      <div className="row ">
        <div className="col-12">
          <div className="row mt-3 mx-2 custom-section-box">
            {/* Present Address Fields */}
            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-12">
                  <h6
                    style={{
                      fontWeight: "700",
                      border: "1px solid #ccc",
                      textAlign: "center",
                      padding: "10px",
                      backgroundColor: "#007BFF",
                    }}
                  >
                    Residence Address
                  </h6>

                  <div className="col-12 mb-2">
                    <label htmlFor="present_address" className="form-label">
                      Address <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      id="present_address"
                      name="present_address"
                      className="form-control detail"
                      placeholder="Enter address"
                      value={formData.present_address || ""}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="col-6 mb-2">
                    <label htmlFor="present_country" className="form-label">
                      Country <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      id="present_country"
                      name="present_country"
                      className="detail"
                      classNamePrefix="present-country-dropdown"
                      placeholder="Select"
                      options={countries.map((country) => ({
                        value: country.countrycode,
                        label: country.countrydesc,
                      }))}
                      value={
                        formData.present_country
                          ? {
                              value: formData.present_country,
                              label:
                                countries.find(
                                  (c) =>
                                    c.countrycode === formData.present_country
                                )?.countrydesc || formData.present_country,
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleInputChange({
                          target: {
                            name: "present_country",
                            value: selectedOption?.value || "",
                          },
                        })
                      }
                      isDisabled={loadingCountries}
                    />
                  </div>

                  <div className="col-6 mb-2">
                    <label htmlFor="present_state" className="form-label">
                      State <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      id="present_state"
                      name="present_state"
                      className="detail"
                      classNamePrefix="present-state-dropdown"
                      placeholder="Select"
                      options={states.map((state) => ({
                        value: state.statecode,
                        label: state.statedesc,
                      }))}
                      value={
                        formData.present_state
                          ? {
                              value: formData.present_state,
                              label:
                                states.find(
                                  (s) => s.statecode === formData.present_state
                                )?.statedesc || formData.present_state,
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleInputChange({
                          target: {
                            name: "present_state",
                            value: selectedOption?.value || "",
                          },
                        })
                      }
                      isDisabled={loadingStates}
                    />
                  </div>

                  <div className="col-6 mb-2">
                    <label htmlFor="present_district" className="form-label">
                      City/District <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      id="present_district"
                      name="present_district"
                      className="detail"
                      classNamePrefix="present-district-dropdown"
                      placeholder="Select"
                      options={cities.map((city) => ({
  value: city.cityname,
  label: city.cityname,
}))}
                      
                      value={
                        formData.present_district
                          ? {
                              value: formData.present_district,
                              label: formData.present_district,
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        {
                          const districtValue = selectedOption?.value || "";
                          handleInputChange({
                            target: {
                              name: "present_district",
                              value: districtValue,
                            },
                          });

                          if ((formData.present_pincode || "").length === 6) {
                            validatePincodeByDistrict(
                              "present_pincode",
                              formData.present_pincode,
                              districtValue
                            );
                          }
                        }
                      }
                      isDisabled={loadingCities}
                    />
                  </div>

                  <div className="col-6 mb-2">
                    <label htmlFor="present_pincode" className="form-label">
                      Pincode <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      id="present_pincode"
                      name="present_pincode"
                      className="form-control detail"
                      placeholder="Enter pincode"
                      value={formData.present_pincode || ""}
                      // onChange={handleInputChange}
                      onChange={(e) => {
                        // Restrict input to only digits (0-9)
                        const value = e.target.value.replace(/[^0-9]/g, ""); // This regex removes any non-numeric character
                        handleInputChange({
                          target: { name: "present_pincode", value },
                        });
                      }}
                      onBlur={() =>
                        validatePincodeByDistrict(
                          "present_pincode",
                          formData.present_pincode || "",
                          formData.present_district || ""
                        )
                      }
                      maxLength={6}
                      required
                    />
                    {errors.present_pincode && (
                      <span
                        style={{
                          color: "red",
                          fontSize: "0.8em",
                          marginTop: "4px",
                          display: "block",
                        }}
                      >
                        {errors.present_pincode}
                      </span>
                    )}
                  </div>
                  <div className="col-6 mb-2">
                    <label
                      htmlFor="present_phone_number"
                      className="form-label"
                    >
                      Phone Number
                    </label>
                    <input
                      type="text"
                      id="present_phone_number"
                      name="present_phone_number"
                      className="form-control detail"
                      placeholder="Enter phone number"
                      value={formData.present_phone_number || ""}
                      onChange={(e) => {
                        // Restrict input to only digits (0-9)
                        const value = e.target.value.replace(/[^0-9]/g, ""); // This regex removes any non-numeric character
                        handleInputChange({
                          target: { name: "present_phone_number", value },
                        });
                      }}
                      maxLength={10}
                    />
                    {errors.present_phone_number && (
                      <span
                        style={{
                          color: "red",
                          fontSize: "0.8em",
                          marginTop: "4px",
                          display: "block",
                        }}
                      >
                        {errors.present_phone_number}
                      </span>
                    )}
                  </div>

                  <div className="col-6 mb-2">
                    <input
                      type="checkbox"
                      id="same-address"
                      checked={isSameAddress}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor="same-address" className="form-label">
                      Permanent address is same as Residence
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {/* Permanent Address Fields */}
            <div className="col-12 col-md-6">
              <h6
                style={{
                  fontWeight: "700",
                  border: "1px solid #ccc",
                  textAlign: "center",
                  padding: "10px",
                  backgroundColor: "#007BFF",
                }}
              >
                Permanent Address
              </h6>
              <div className="col-12 mb-2">
                <label htmlFor="permanent_address" className="form-label">
                  Address <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  id="permanent_address"
                  name="permanent_address"
                  className="form-control detail"
                  placeholder="Enter permanent address"
                  value={formData.permanent_address || ""}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="col-6 mb-2">
                <label htmlFor="permanent_district" className="form-label">
                  City/District <span style={{ color: "red" }}>*</span>
                </label>
                <Select
                  id="permanent_district"
                  name="permanent_district"
                  className="detail"
                  classNamePrefix="city-dropdown"
                  placeholder="Select"
                  options={cities.map((city) => ({

  value: city.cityname,
  label: city.cityname,
}))}

                  value={
                    formData.permanent_district
                      ? {
                          value: formData.permanent_district,
                          label: formData.permanent_district,
                        }
                      : null
                  }
                  onChange={(selectedOption) =>
                    {
                      const districtValue = selectedOption?.value || "";
                      handleInputChange({
                        target: {
                          name: "permanent_district",
                          value: districtValue,
                        },
                      });

                      if ((formData.permanent_pincode || "").length === 6) {
                        validatePincodeByDistrict(
                          "permanent_pincode",
                          formData.permanent_pincode,
                          districtValue
                        );
                      }
                    }
                  }
                  isDisabled={loadingCities}
                />
              </div>

              <div className="col-6 mb-2">
                <label htmlFor="permanent_state" className="form-label">
                  State <span style={{ color: "red" }}>*</span>
                </label>
                <Select
                  id="permanent_state"
                  name="permanent_state"
                  className="detail"
                  classNamePrefix="state-dropdown"
                  placeholder="Select"
                  options={states.map((state) => ({
                    value: state.statecode,
                    label: state.statedesc,
                  }))}
                  value={
                    formData.permanent_state
                      ? {
                          value: formData.permanent_state,
                          label:
                            states.find(
                              (s) => s.statecode === formData.permanent_state
                            )?.statedesc || formData.permanent_state,
                        }
                      : null
                  }
                  onChange={(selectedOption) =>
                    handleInputChange({
                      target: {
                        name: "permanent_state",
                        value: selectedOption?.value || "",
                      },
                    })
                  }
                  isDisabled={loadingStates}
                />
              </div>

              <div className="col-6 mb-2">
                <label htmlFor="permanent_country" className="form-label">
                  Country <span style={{ color: "red" }}>*</span>
                </label>
                <Select
                  id="permanent_country"
                  name="permanent_country"
                  className="detail"
                  classNamePrefix="country-dropdown"
                  placeholder="Select"
                  options={countries.map((country) => ({
                    value: country.countrycode,
                    label: country.countrydesc,
                  }))}
                  value={
                    formData.permanent_country
                      ? {
                          value: formData.permanent_country,
                          label:
                            countries.find(
                              (c) =>
                                c.countrycode === formData.permanent_country
                            )?.countrydesc || formData.permanent_country,
                        }
                      : null
                  }
                  onChange={(selectedOption) =>
                    handleInputChange({
                      target: {
                        name: "permanent_country",
                        value: selectedOption?.value || "",
                      },
                    })
                  }
                />
              </div>

              <div className="col-6 mb-2">
                <label htmlFor="permanent_pincode" className="form-label">
                  Pincode <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  id="permanent_pincode"
                  name="permanent_pincode"
                  className="form-control detail"
                  placeholder="Enter pincode"
                  value={formData.permanent_pincode || ""}
                  // onChange={handleInputChange}
                  onChange={(e) => {
                    // Restrict input to only digits (0-9)
                    const value = e.target.value.replace(/[^0-9]/g, ""); // This regex removes any non-numeric character
                    handleInputChange({
                      target: { name: "permanent_pincode", value },
                    });
                  }}
                  onBlur={() =>
                    validatePincodeByDistrict(
                      "permanent_pincode",
                      formData.permanent_pincode || "",
                      formData.permanent_district || ""
                    )
                  }
                  maxLength={6}
                  required
                />
                {errors.permanent_pincode && (
                  <span
                    style={{
                      color: "red",
                      fontSize: "0.8em",
                      marginTop: "4px",
                      display: "block",
                    }}
                  >
                    {errors.permanent_pincode}
                  </span>
                )}
              </div>
              <div className="col-6 mb-2">
                <label htmlFor="permanent_phone_number" className="form-label">
                  Phone Number
                </label>
                <input
                  type="text"
                  id="permanent_phone_number"
                  name="permanent_phone_number"
                  className="form-control detail"
                  placeholder="Enter phone number"
                  value={formData.permanent_phone_number || ""}
                  // onChange={handleInputChange}

                  onChange={(e) => {
                    // Restrict input to only digits (0-9)
                    const value = e.target.value.replace(/[^0-9]/g, ""); // This regex removes any non-numeric character
                    handleInputChange({
                      target: { name: "permanent_phone_number", value },
                    });
                  }}
                  maxLength={10}
                />

                {errors.permanent_phone_number && (
                  <span
                    style={{
                      color: "red",
                      fontSize: "0.8em",
                      marginTop: "4px",
                      display: "block",
                    }}
                  >
                    {errors.permanent_phone_number}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParentDetailsForm;